import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import GlobalObjetive from './AvailabilityGlobalObjetive/index'
import StepAvailability from './LastAvailabilityStep/index'
import Paper from '@material-ui/core/Paper';
import moment from 'moment-timezone'
import 'moment/locale/es'
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import ListObjectiveModal from '../../ListObjectiveModal';
import Filter from '../../../../../helpers/Filter'
import compose from 'recompose/compose';
// Material helpers
import { withStyles } from '@material-ui/core/styles';
// Component styles
import styles from './styles';

import 'moment/locale/es'
import { FilterTags } from '../../../../../components/TagsAtentus/FilterTags';
import queryString from 'query-string';
import { sidebarFiltersTags } from '../../../../../utils/local-storage/sidebar-options';
import { Box, Dialog, FormControlLabel, Switch, Tooltip } from '@material-ui/core';
import { withOperativeStateStore } from '../../../../../store/useOperativeStateConfig';
import { withTranslation } from 'react-i18next';
moment.locale('es')

class OperativeControl extends Component {

    constructor(props) {        
        super(props);
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        const estados = [t('filter.status-list.Activos'), t('filter.status-list.Downtime'), t('filter.status-list.Downtime-Parcial'), t('filter.status-list.Uptime'), t('filter.status-list.Todos')];
        this.infoAutoComplete = this.handleState.bind(this);
        const parsed = queryString.parse(props.location.search);
        const etiquetas = parsed?.etiquetas && parsed?.etiquetas !== ''
            ? parsed?.etiquetas.split('T').map(e => Number(e)) ?? [] : [];
        let filter = parsed?.estado;
        var filterList=[{"nombre":t('filter.status-list.Activos')},{"nombre":t('filter.status-list.Downtime')}, {"nombre":t('filter.status-list.Downtime-Parcial')}, {"nombre":t('filter.status-list.Uptime')},{"nombre":t('filter.status-list.Todos')}]
        if(!filter && sessionStorage.getItem("filterOperative")!==null){
            filter=sessionStorage.getItem("filterOperative")
        } else if (!filter || !estados.includes(filter)) {
            filter = "Activos"
        }
        var newFilterList=[{"nombre":t('filter.status-list.'+filter)}]
        filterList.forEach(ele=>{
            if(ele.nombre!==filter){
                newFilterList.push(ele)
            }
        })
        filterList=newFilterList

        const filterTypeFromStorage = sidebarFiltersTags.getFilterType();
        
        const filterType = parsed?.filterType ?? filterTypeFromStorage;

        this.state = {
            listObjetives:{},
            listObjetivesData:this.props.params.listObjetivesData,
            isLoading:true,
            token:sessionStorage.getItem('key'),
            user:sessionStorage.getItem("user"),
            dateDowntime:(moment().tz(sessionStorage.getItem('tz')).format("MMMM YYYY, HH:mm:ss a")),
            open: false, 
            objmodal: 0,
            objNameModal: '',
            changeFilter:false,
            filter:filter,
            filterList:filterList,
            intervalId: null,
            downList: [],
            parcialList: [],
            uptimeList: [],
            noMonitoring: [],
            filterTagsId: etiquetas,
            filterTagsType: filterType,
        }
    }
    
    componentDidMount() {
        this.processData();
        const newInterval = setInterval(() => this.processData(), 300000);
        this.setState({intervalId: newInterval});
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.state.loadObjectiveData|| !this.state.listObjetivesData|| prevState.changeFilter!== this.state.changeFilter) {   
            //console.log('update')
            this.processData()
        }
        if (this.props.t !== prevProps.t) {
            const queryParamsParsed = queryString.parse(document.location.search);
            queryParamsParsed["etiquetas"] = this.state.filterTagsId.join("T");
            queryParamsParsed["filterType"] = this.state.filterTagsType;
            queryParamsParsed['estado'] = this.state.filter
            queryParamsParsed['filterTagsType'] = this.state.filterTagsType;
            window.history.replaceState(
                null,
                'Estado Operativo',
                `/estadoOperativo?${queryString.stringify(
                    queryParamsParsed,                
                )}`
            );
            var filterList=[{"nombre":this.props.t('filter.status-list.Activos')},
                {"nombre":this.props.t('filter.status-list.Downtime')}, 
                {"nombre":this.props.t('filter.status-list.Downtime-Parcial')}, 
                {"nombre":this.props.t('filter.status-list.Uptime')},
                {"nombre":this.props.t('filter.status-list.Todos')}]
            this.setState({filterList: filterList});
        }
    }

    processData = () => {
        const { params } = this.props;
        const {filter}=this.state
        const downtimeList = params.listObjetivesData.Downtime
        const partialList = params.listObjetivesData.Partial
        const uptimeList = params.listObjetivesData.Uptime
        const noMonitoringList = params.listObjetivesData.NoMonitoring
        downtimeList.sort(function (a, b) {
            let nombreA = (a.nombre).toLowerCase()
            let nombreB = (b.nombre).toLowerCase()
            if (nombreA < nombreB) return -1;
            if (nombreA > nombreB) return 1;
            return 0;
        })
        partialList.sort(function (a, b) {
            let nombreA = (a.nombre).toLowerCase()
            let nombreB = (b.nombre).toLowerCase()
            if (nombreA < nombreB) return -1;
            if (nombreA > nombreB) return 1;
            return 0;
        })
        uptimeList.sort(function (a, b) {
            let nombreA = (a.nombre).toLowerCase()
            let nombreB = (b.nombre).toLowerCase()
            if (nombreA < nombreB) return -1;
            if (nombreA > nombreB) return 1;
            return 0;
        })
        noMonitoringList.sort(function (a, b) {
            let nombreA = (a.nombre).toLowerCase()
            let nombreB = (b.nombre).toLowerCase()
            if (nombreA < nombreB) return -1;
            if (nombreA > nombreB) return 1;
            return 0;
        })
        sessionStorage.setItem("filterOperative", filter)
        if(filter==="Activos"){
            this.setState({
                listObjectives: params.listObjetivesData,
                loadObjectiveData: true,
                downList:downtimeList,
                parcialList:partialList,
                uptimeList:uptimeList,
                noMonitoring:[],
                listObjetivesData:params.listObjetivesData,
                isLoading:false,
                dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("MMMM YYYY, HH:mm:ss a"))
            });
        }
        if(filter==="Downtime"){
            this.setState({
                listObjectives: params.listObjetivesData,
                loadObjectiveData: true,
                downList:downtimeList,
                parcialList:[],
                uptimeList:[],
                noMonitoring:[],
                listObjetivesData:params.listObjetivesData,
                isLoading:false,
                dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("MMMM YYYY, HH:mm:ss a"))
            });
        }
        if(filter==="Downtime-Parcial"){
            this.setState({
                listObjectives: params.listObjetivesData,
                loadObjectiveData: true,
                downList:[],
                noMonitoring:[],
                parcialList:partialList,
                uptimeList:[],
                listObjetivesData:params.listObjetivesData,
                isLoading:false,
                dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("MMMM YYYY, HH:mm:ss a"))
            });
        }
        if(filter==="Uptime"){
            this.setState({
                listObjectives: params.listObjetivesData,
                loadObjectiveData: true,
                downList:[],
                noMonitoring:[],
                parcialList:[],
                uptimeList:uptimeList,
                listObjetivesData:params.listObjetivesData,
                isLoading:false,
                dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("MMMM YYYY, HH:mm:ss a"))
            });
        }
        if(filter==="Todos"){
            //console.log("handle", params.listObjetivesData)
            this.setState({
                listObjectives: params.listObjetivesData,
                loadObjectiveData: true,
                downList:downtimeList,
                parcialList:partialList,
                uptimeList:uptimeList,
                noMonitoring:noMonitoringList,
                listObjetivesData:params.listObjetivesData,
                isLoading:false,
                dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("MMMM YYYY, HH:mm:ss a"))
            });
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId)
    }

    handleOpen = event => {       
        const objId = event.currentTarget.id
        const objName = event.currentTarget.value       
        if (!this.state.open){
            this.setState({
                open: true,
                objIdModal: objId,
                objNameModal: objName
            })
        }        
    };
    
    handleClose = event => {
        this.setState({
            open: false,
        })
    };

    getObjetives(obj, type, t){
        const {classes} = this.props    
        let divPaperColor= "#41B900"
        if(type==="down"){
            divPaperColor="#C2272D"
        }
        if(type==="parcial"){
            divPaperColor="#FFC600"
        }
        if(type==="noMon"){
            divPaperColor="#bdbdbd"
        }
        var Availability=<Graph data={obj}/>
        return(
            <Grid
                key={obj.descripcion}
                item
                xs={12}
                sm={12}
                md={6}
                lg={4}
                xl={3}
                xxl={2}
                >
                <Paper style={{
                    borderColor: divPaperColor,
                    borderStyle: 'solid',
                    borderRadius: 10,
                    background: "#ffffff",
                    boxShadow: "5px 5px 11px #c9c9c9,-5px -5px 11px #ffffff",
                    borderWidth: 2,
                }}>
                    <Tooltip title={t('operative-status.tooltip')}>
                        <Box
                            id={obj.objetivo_id}
                            value={obj.nombre}
                            onClick={this.handleOpen}
                            style={{
                                width:"100%",
                                height:"150px",
                                backgroundColor: divPaperColor,
                                borderTopLeftRadius: 6,
                                borderTopRightRadius: 6,
                                cursor: 'pointer'
                            }}
                            display='flex'
                            flexDirection='column'
                            justifyContent='center'
                            alignItems='center'
                        >
                            <Box>
                                <Typography className={classes.objectiveName}>{obj.nombre}</Typography>
                            </Box>
                            <Box style={{marginTop: 20}}>
                                {Availability}
                            </Box>
                        </Box>
                    </Tooltip>
                    <GraphStep data={obj.nombre} id={obj.objetivo_id} state={obj.estado} />
                </Paper>
            </Grid>
        )
               
    }

    handleState=(e,x)=>{
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        var stateObj =  x.nombre
        var statusName = "Activos"
        if(stateObj===t('filter.status-list.Downtime')){
            statusName = "Downtime"
            this.setState({
                parcial:[], 
                uptime:[],
                changeFilter:!this.state.changeFilter, 
                filter:"Downtime"
            });
        }else if(stateObj===t('filter.status-list.Downtime-Parcial')){
            statusName = "Downtime-Parcial"
            this.setState({
                downtime:[], 
                uptime:[],
                changeFilter:!this.state.changeFilter, 
                filter:"Downtime-Parcial"
            });
        }else if(stateObj===t('filter.status-list.Uptime')){
            statusName = "Uptime"
            this.setState({
                downtime:[],
                parcial:[],
                changeFilter:!this.state.changeFilter, 
                filter:"Uptime"
            })
        }else if(stateObj===t('filter.status-list.Todos')){
            statusName = "Todos"
            this.setState({
                changeFilter:!this.state.changeFilter, 
                filter:"Todos"
            });
        }else if(stateObj===t('filter.status-list.Activos')){
            statusName = "Activos"
            this.setState({
                changeFilter:!this.state.changeFilter, 
                filter:"Activos"
            });
        }

        const queryParamsParsed = queryString.parse(document.location.search);
        queryParamsParsed['etiquetas'] = this.state.filterTagsId.join('T')
        queryParamsParsed['estado'] = statusName
        queryParamsParsed['filterType'] = this.state.filterTagsType
        window.history.replaceState(
            null,
            'Estado Operativo',
            `/estadoOperativo?${queryString.stringify(queryParamsParsed)}`
        )
    }

    updateEtiquetas = (etiquetas, filterType) => {
        const ids = etiquetas.map(etiqueta => etiqueta.etiqueta_id)
        this.setState({filterTagsId: ids, filterTagsType: filterType})

        const queryParamsParsed = queryString.parse(document.location.search);
        queryParamsParsed['etiquetas'] = ids.join('T')
        queryParamsParsed['estado'] = this.state.filter
        queryParamsParsed['filterType'] = filterType
        window.history.replaceState(
            null,
            'Estado Operativo',
            `/estadoOperativo?${queryString.stringify(queryParamsParsed)}`
        )
    }

    objectivesListFilteredByTags = () => {
        const listObjectives = {
            downList: this.state.downList,
            parcialList: this.state.parcialList,
            uptimeList: this.state.uptimeList,
            noMonitoring: this.state.noMonitoring,
        }
        if (this.state.filterTagsId.length === 0) return listObjectives
        const newListObjectives = {}
        for (const state in listObjectives) {
            const filtered = listObjectives[state].filter(obj => {
                if (!obj.Etiquetas) return false
                let tieneEtiquetas = true

                if (this.state.filterTagsType === "AND") {
                    for (const id of this.state.filterTagsId) {
                        if (!obj.Etiquetas.find(et => et.etiqueta_id === id)) {
                            tieneEtiquetas = false
                            break;
                        }
                    }
                } else {
                    tieneEtiquetas = obj.Etiquetas.filter(et => this.state.filterTagsId.includes(et.etiqueta_id)).length
                }
                return tieneEtiquetas
            })
            newListObjectives[state] = filtered
        }
        newListObjectives['listObjetivesData'] = this.state.listObjetivesData
        return newListObjectives
    }

    handleChangeSwitchAutoScroll = (event) => {
        this.props.store.changeAutoPlaySliderValue()
    }

    getObjetivesList(downtime, parcial, uptime, noMon, t){
        const {filter, filterList}=this.state
        var filterGrid=
                    <Grid
                        container
                        spacing={3}
                    >
                        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                            <Filter
                                list={filterList}
                                label={t('text.select-status')} 
                                InfoAutoComplete={this.handleState}
                                placeholder={t('text.status')}
                                default={t('filter.status-list.'+filter)}
                            />
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                            <FilterTags
                                listObjectives={[]}
                                updateEtiquetas={(etiqueta, filterType = "OR") => this.updateEtiquetas(etiqueta, filterType)}
                                tagsId={this.state.filterTagsId}
                                preload={true}
                                filterTagsType={this.state.filterTagsType}
                                showFilterType={true}
                            />
                        </Grid>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                            <Box display='flex' justifyContent='end' style={{marginBottom: 30}}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            color='primary'
                                            name='checkActivateAutoScroll'
                                            checked={this.props.store.autoPlaySlider}
                                            onChange={this.handleChangeSwitchAutoScroll}
                                        />
                                    }
                                    label={`${this.props.store.autoPlaySlider ? t('online.auto-refresh.deactivate') : t('online.auto-refresh.activate')} auto-scroll`}
                                />
                            </Box>
                        </Grid>
                    </Grid>
        var dataObjs=<Grid
                        container
                        spacing={6}
                        >
                        {(downtime).map(down => (
                            
                            this.getObjetives(down, "down", t)
                        ))}
                        {(parcial).map( parcial=> (
                            
                            this.getObjetives(parcial, "parcial", t)
                        ))}
                        {(uptime).map(uptimeObj => (
                            this.getObjetives(uptimeObj, "uptime", t)
                        ))}
                        {(noMon).map(noMonObj => (
                            this.getObjetives(noMonObj, "noMon", t)
                        ))}
                    </Grid>
        if(downtime.length===0 &&parcial.length===0&& uptime.length===0&&noMon.length===0){
            dataObjs=<Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        xxl={12}
                        spacing={3}
                        style={{"paddingBottom":"40px"}}
                    ><Typography variant="h6">{t('operative-status.filter.text.no-objectives')} {filter}</Typography></Grid>
        }
        
        return(
            <PortletContent>
                {filterGrid}
                {dataObjs}
            </PortletContent>
        )
               
    }
    
    render() {
        const list = this.objectivesListFilteredByTags()
        const { isLoading, listObjetivesData, open, objIdModal, objNameModal } = this.state;
        const { classes } = this.props;
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (isLoading===true) {
            return(
                <PortletContent>
                    <Typography
                        variant="h5"
                    >
                        <CircularProgress
                        variant="indeterminate"   
                        size={24}
                        thickness={4}
                    />
                    <br/>
                        {t('text.loading')}
                    </Typography>
                </PortletContent>
            )
        }else if(isLoading===false){
            const {uptimeList, downList, parcialList, noMonitoring}=list
            return(
                <div>
                    <div>
                        {this.getObjetivesList(downList,parcialList, uptimeList, noMonitoring, t)}
                    </div>
                    <div>
                        <Dialog
                            maxWidth='lg'
                            fullWidth
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            open={open}
                            onClose={this.handleClose}
                            closeAfterTransition
                            disableAutoFocus={true}
                            disableEnforceFocus={true}
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                                timeout: 500,
                            }}
                        >                                    
                            <Fade in={open}>                       
                                <ListObjectiveModal obj={objIdModal} objName={objNameModal} listObjectives={listObjetivesData} handleClose={this.handleClose}/>                        
                            </Fade>
                        </Dialog>
                    </div>
                </div>
            )
        }
        else return (<p>Error!</p>)
    }
}

function Graph(data) {
    return <GlobalObjetive data={data} />

}

function GraphStep(data) {
    return <StepAvailability data={data}/>
}


export default compose(withRouter, withStyles(styles), withOperativeStateStore, withTranslation())(OperativeControl);